import React, { useState } from 'react';
import { getLoginUserData } from '../../Helper/GlobalHelperFunction';
import Resizer from "react-image-file-resizer";
import { CreateOrUpdateAsset } from '../../Helper/AssetHelper/AssetHelper';
import { toast } from 'react-toastify';

const CreateAssetComponent = () => {
    const id = getLoginUserData().id;
    const [inputField, setInputField] = useState({
        assetId: 0,
        assetName: "",
        totalQuantity: 0,
        assetType: "",
        length: "",
        bredth: "",
        height: "",
        material: "",
        description: "",
        color: "",
        createdBy: id,
        updatedBy: 0,
    });

    const handleInputChange = (evt) => {
        const { name, value } = evt.target;
        setInputField((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    // Image data
    const [inputImageData, setInputImageData] = useState([
        {
            id: 0,
            date: Date.now(),
            imageId: 0,
            imageSrc: "",
            createdBy: id,
            updatedBy: 0,
        }
    ]);

    const addImage = () => {
        setInputImageData([...inputImageData, {
            id: 0,
            date: Date.now(), // Unique identifier
            imageId: 0,
            imageSrc: "",
            createdBy: id,
            updatedBy: 0,
            imageDetails: []
        }]);
    };

    const removeImage = (index) => {
        const updatedImages = inputImageData.filter((_, i) => i !== index);
        setInputImageData(updatedImages);
    };

    const handleImageChange = (index, evnt) => {
        const { files } = evnt.target;
        const file = files[0];
        if (file) {
            Resizer.imageFileResizer(
                file,
                800, // Max width
                800, // Max height
                "webp", // Output format
                90, // Quality (0 to 100)
                0, // Rotation (in degrees)
                (uri) => {
                    const updatedImages = [...inputImageData];
                    updatedImages[index].imageSrc = uri; // Assign Base64 image to `imageSrc`
                    setInputImageData(updatedImages);
                },
                "base64" // Output type
            );
        }
    };

    const save = async (evt) => {
        // evt.preventDefault();
        const data = {
            ...inputField,
            imageDetails: inputImageData,
        };
        console.log(data);
        debugger
        const res = await CreateOrUpdateAsset(data);
        if (res.code === 200) {
            toast.success("Asset Saved Successfully");
        }
        else {
            toast.error("Failed to save asset");
        }
    };

    return (
        <div>
            <div className="container-fluid p-3">
                <div className="card mb-3 shadow-sm">
                    <div className="card-body">
                        <h2>Add Assets</h2>
                    </div>
                </div>

                <form onSubmit={(e) => { e.preventDefault(); save(); }} className='form-control'>
                    <div className="row">
                        <div className="col-sm-12 px-3 d-flex flex-wrap">
                            <div className="col-sm-5 col-12 ">
                                <div className="form-group">
                                    <label><b>Asset Name</b></label>
                                    <input type="text" className="form-control" onChange={handleInputChange} name='assetName' placeholder="Enter Asset Name" />
                                </div>
                                <div className="form-group">
                                    <label ><b>Quantity</b></label>
                                    <input type="number" className="form-control" onChange={handleInputChange} name='totalQuantity' placeholder="Enter Quantity" />
                                </div>
                                <div className="form-group">
                                    <label ><b>Color</b></label>
                                    <input type="text" className="form-control" onChange={handleInputChange} name='color' placeholder="Enter Color" />
                                </div>
                                <div className="form-group">
                                    <label ><b>Asset Type</b></label>
                                    <select type="text" className="form-select" onChange={handleInputChange} name='assetType' placeholder="Enter Description" >
                                        <option value="NONE">NONE</option>
                                        <option value="RENTAL">RENTAL</option>
                                        <option value="IN-HOUSE">IN-HOUSE</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-sm-2 ">

                            </div>
                            <div className="col-sm-5 col-12 ">
                                <div className="col-12 d-flex">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label ><b>Length</b></label>
                                            <input type="text" className="form-control" onChange={handleInputChange} name='length' placeholder="Enter Length" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label ><b>Bredth</b></label>
                                            <input type="text" className="form-control" onChange={handleInputChange} name='bredth' placeholder="Enter Bredth" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label ><b>Height</b></label>
                                            <input type="text" className="form-control" onChange={handleInputChange} name='height' placeholder="Enter Height" />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label ><b>Material</b></label>
                                    <input type="text" className="form-control" onChange={handleInputChange} name='material' placeholder="Enter Material" />
                                </div>
                                <div className="form-group">
                                    <label ><b>Description</b></label>
                                    <textarea cols={10} rows={2} className="form-control" onChange={handleInputChange} name='description' placeholder="Enter Description" />
                                </div>

                            </div>
                        </div>
                        <div className="col-sm-12 mt-2">
                            <div className="form-group row">
                                <div className="col-sm-7 h5"><b>Add Images</b></div>
                            </div>

                            {inputImageData.map((data, index) => {
                                const { imageSrc } = data;

                                return (
                                    <div className="form-group row d-flex  align-items-center" key={data.date}>
                                        <div className='col-sm-5'>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                onChange={(evnt) => handleImageChange(index, evnt)}
                                                name="imageSrc"
                                                className="form-control"
                                            />
                                        </div>
                                        <div className="col-sm-3 text-center m-1 rounded p-1 border border-2 border-secondary">
                                            {imageSrc ? (
                                                <img src={imageSrc} className='img-fluid' alt={`Preview ${index + 1}`} style={{ height: "100px", objectFit: "contain" }} />
                                            ) : (
                                                <p className="text-muted" style={{ fontSize: "0.9rem" }}>No image uploaded</p>
                                            )}
                                        </div>
                                        <div className="col-sm-1 ml-3">
                                            <span className="btn btn-sm btn-outline-success" onClick={addImage}>Add Row</span>
                                        </div>
                                        {inputImageData.length > 1 && (
                                            <div className='col-sm-1'>
                                                <span className="btn btn-sm btn-outline-danger" onClick={() => removeImage(index)}>×</span>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                        <button type="submit" className="btn btn-primary mt-3">
                            Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateAssetComponent;
